import { render, staticRenderFns } from "./TravelFinalizationPage.vue?vue&type=template&id=0df49926&scoped=true"
import script from "./TravelFinalizationPage.vue?vue&type=script&lang=js"
export * from "./TravelFinalizationPage.vue?vue&type=script&lang=js"
import style0 from "./TravelFinalizationPage.vue?vue&type=style&index=0&id=0df49926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df49926",
  null
  
)

export default component.exports